import './rate-per-pax.scss';

import { Outlet } from "react-router-dom";

import { FilterRatePerPaxProvider } from "./filter-rate-per-pax/filter-rate-per-pax.context";

export function RatePerPax() {
  return (
    <div id="ShellRatePerPax" className="rate-per-pax">
       <FilterRatePerPaxProvider>
        <Outlet />
      </FilterRatePerPaxProvider>
    </div>
  );
}

export default RatePerPax;
